<template>
  <div id="app">
    <transition name="custom">
      <router-view />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'app',
  computed: {
    ...mapGetters(['checkIfQuestions'])
  },
  mounted () {
    // if quiz empty, return to homepage
    if (!this.checkIfQuestions) {
      this.$router.push('/')
    }
  },
  watch: {
    $route () {
      if (window.innerHeight < 1000) {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/_variables';

html, body {
  margin: 0;
  height: 100%;
  position:relative;
  overflow-x:hidden;
  font-size: 16px;
  line-height: 1.25;
  @media (max-width: $mdm){
    height: auto;
    min-height: 100vh;
  }
  @media (max-height: 950px){
    height: auto;
    min-height: 100vh;
  }
}

body {
  background: $grey;
  padding: 0;
  margin: 0;
  background-image: url('./assets/images/background.jpg');
  background-size: cover;
  background-position: center;
  display: -webkit-flex;
  display: -ms-flex;
  display: flex;
  align-items: center;
  justify-content: center;
}

#app {
  box-sizing: border-box;
  font: {
    size: 14px;
    weight: $font_n;
    family: $font_fam;
  }
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;

  padding: $pad*3 $pad*4 $pad*4 $pad*4;
  margin: 0 auto;

  background-color: $white;
  width: 900px;
  max-width: 96%;
  border-radius: 16px;

  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  overflow: hidden;

  @media (max-width: $mdm){
    padding: $pad*2 $pad*2;
    margin: $pad*2 auto;
  }
  @media (max-height: 950px){
    padding: $pad*2 $pad*2;
    margin: $pad*2 auto;
  }
}
</style>
